import axios from "axios";
import { getToken, handleSessionTimeout, getAuthIDFromUrl } from "./auth";

const API_URL = process.env.REACT_APP_CORE_API;
const UPLOAD_API_URL = process.env.REACT_APP_UPLOAD_API;

// -----------------------------------------------------
// Upload File - Extraction API
// -----------------------------------------------------
export const uploadPayrollFile = async (file,corporation_id,/* s3response,*/ payrollType, pc_id) => {
    try {
        if (!file) throw new Error("File is required");

        const authId = getAuthIDFromUrl();
        const formData = new FormData();
        formData.append("file", file);
        formData.append("auth_id", authId);
        formData.append("corporation_id", corporation_id);
        formData.append("pc_id", pc_id || "");
        formData.append("payroll_type", payrollType);

        const response = await axios.post(
            `${UPLOAD_API_URL}`,
            formData,
            {
                headers: {
                    Accept: "application/json",
                },
            }
        );

        return response.data;
    } catch (error) {
        if (error.response?.status === 401) {
            handleSessionTimeout();
        }
        throw error;
    }
};


// -----------------------------------------------------
// Axios Helpers
// -----------------------------------------------------
const authHeaders = (token) => ({
    headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Content-Type": "application/json",
    },
});

export const cacheImportedPayroll = async (corpId) => {
    try {
        const tokenData = await getToken();
        const response = await axios.post(
            `${API_URL}/v1/PayrollEntry/CacheImportedPayroll`,
            { CorpID: corpId },
            authHeaders(tokenData?.token)
        );
        return response.data;
    } catch (error) {
        if (error.response?.status === 401) {
            handleSessionTimeout();
        }
        console.error("Error caching imported payroll:", error);
        throw error;
    }
};

export const validateAuth = async () => {
    const tokenData = await getToken();
    return tokenData?.statusCode === 200 ? tokenData : null;
};




// export const getViewGrid = async (payload) => {
//     try {
//         const tokenData = await getToken();

//         const response = await axios.post(
//             `${API_URL}/v1/PayrollEntry/Viewgrid`,
//             payload,
//             authHeaders(tokenData?.token)
//         );
//         return response.data;
//     } catch (error) {
//         if (error.response?.status === 401) {
//             handleSessionTimeout();
//         }
//         console.error("Error fetching payroll entry grid:", error);
//         throw error;
//     }
// };



// export const deletePayrollEntry = async (payrollId) => {
//     try {
//         const tokenData = await getToken();
//         const response = await axios.post(
//             `${API_URL}/v1/PayrollEntry/DeletePayroll?PayrollID=${payrollId}`,
//             {},
//             authHeaders(tokenData?.token)
//         );
//         return response.data;
//     } catch (error) {
//         if (error.response?.status === 401) {
//             handleSessionTimeout();
//         }
//         console.error("Error deleting payroll entry:", error);
//         throw error;
//     }
// };


// export const loadPayPeriodSetup = async (payrollId) => {
//     if (!payrollId) return null;
//     try {
//         const tokenData = await getToken();
//         const url = `${API_URL}/v1/PayrollEntry/LoadPayPeriodSetup?PayrollID=${payrollId}`;

//         const response = await axios.post(url, {}, authHeaders(tokenData?.token));
//         return response.data || null;
//     } catch (error) {
//         if (error.response?.status === 401) {
//             handleSessionTimeout();
//         }
//         console.error("Error loading pay period setup:", error);
//         throw error;
//     }
// };



// export const updatePayPeriodSetup = async (payload) => {
//     try {
//         const tokenData = await getToken();
//         const res = await axios.post(
//             `${API_URL}/v1/PayrollEntry/UpdatePayPeriodSetup`,
//             payload,
//             authHeaders(tokenData?.token)
//         );
//         return res.data;
//     } catch (error) {
//         if (error.response?.status === 401) {
//             handleSessionTimeout();
//         }
//         console.error("Error updating pay period setup:", error);
//         throw error;
//     }
// };



// export const getLoadEmpPayrollDetails = async (payrollId) => {
//     try {
//         const tokenData = await getToken();
//         const url = `${API_URL}/v1/PayrollEntry/LoadEmployeesPayrollDetails?PayrollID=${payrollId}`;

//         const response = await axios.post(url, {}, authHeaders(tokenData?.token));
//         return response.data || null;
//     } catch (error) {
//         if (error.response?.status === 401) {
//             handleSessionTimeout();
//         }
//         console.error("Error loading employee payroll details:", error);
//         throw error;
//     }
// };


// export const getDefaultDateRange = async () => {
//     try {
//         const tokenData = await getToken();
//         const response = await axios.get(
//             `${PAYABLE_API_URL}/v1/viewtransactionrangepref`,
//             authHeaders(tokenData?.token)
//         );
//         return response.data;
//     } catch (error) {
//         if (error.response?.status === 401) {
//             handleSessionTimeout();
//         }
//         console.error("Error fetching default date range:", error);
//         throw error;
//     }
// };



// export const getPayrollEmployeeDetails = async (payrollId) => {
//     try {
//         const tokenData = await getToken();
//         const url = `${API_URL}/v1/PayrollEntry/GetPayrollEmployeeMapping?payrollEmpID=${payrollId}`;

//         const response = await axios.post(url, {}, authHeaders(tokenData?.token));
//         return response.data || null;
//     } catch (error) {
//         if (error.response?.status === 401) {
//             handleSessionTimeout();
//         }
//         console.error("Error loading employee payroll details:", error);
//         throw error;
//     }
// };


// export const UpdatePayrollEmployeeMapping = async (payload) => {
//     try {
//         const tokenData = await getToken();
//         const res = await axios.post(
//             `${API_URL}/v1/PayrollEntry/UpdatePayrollEmployeeMapping`,
//             payload,
//             authHeaders(tokenData?.token)
//         );
//         return res.data;
//     } catch (error) {
//         if (error.response?.status === 401) {
//             handleSessionTimeout();
//         }
//         console.error("Error updating payroll employee mapping:", error);
//         throw error;
//     }
// };


// export const getBillEntryPreferences = async (corpId) => {
//     try {
//         const tokenData = await getToken();
//         const response = await axios.get(
//             `${PAYABLE_API_URL}/v1/getBillEntryPreferences?CorpID=${corpId}`,
//             authHeaders(tokenData?.token)
//         );
//         if (response.data) {
//             response.data.voidDate = true;
//         }
//         return response.data || null;
//     } catch (error) {
//         if (error.response?.status === 401) {
//             handleSessionTimeout();
//         }
//         console.error("Error fetching payroll entry preferences:", error);
//         throw error;
//     }
// };


// // export const getDeptJobDetails = async (EmployeeId) => {
// //     try {
// //         const tokenData = await getToken();
// //         const url = `${API_URL}/v1/PayrollEntry/GetDeptJobDetails?EmployeeID=${EmployeeId}`;

// //         const response = await axios.post(url, {}, authHeaders(tokenData?.token));
// //         return response.data || null;
// //     } catch (error) {
// //         if (error.response?.status === 401) {
// //             handleSessionTimeout();
// //         }
// //         console.error("Error loading department and job details:", error);
// //         throw error;
// //     }
// // };


// export const getDeptJobDetails = async (EmployeeId) => {
//     try {
//         const tokenData = await getToken();
//         const url = `${API_URL}/v1/PayrollEntry/GetDeptJobDetails?EmployeeID=${EmployeeId}`;

//         const response = await axios.post(url, {}, authHeaders(tokenData?.token));
//         return response.data || null;
//     } catch (error) {
//         if (error.response?.status === 401) {
//             handleSessionTimeout();
//         }
//         console.error("Error loading department and job details:", error);
//         throw error;
//     }
// };


// export const updateVoidDate = async (payload) => {
//     try {
//         const tokenData = await getToken();
//         const response = await axios.post(
//             `${API_URL}/v1/PayrollEntry/PayrollEmpVoid`,
//             payload,
//             authHeaders(tokenData?.token)
//         );
//         return response.data || null;
//     } catch (error) {
//         if (error.response?.status === 401) {
//             handleSessionTimeout();
//         }
//         console.error("Error updating void date:", error);
//         throw error;
//     }
// };

// export const isLock = async (payload) => {
//     try {
//         const tokenData = await getToken();
//         const response = await axios.post(
//             `${PAYABLE_API_URL}/v1/CorporationLockCheck`,
//             payload,
//             authHeaders(tokenData?.token)
//         );
//         return response.data || null;
//     } catch (error) {
//         if (error.response?.status === 401) {
//             handleSessionTimeout();
//         }
//         console.error("Error updating void date:", error);
//         throw error;
//     }
// };

// export const getValidatePassword = async (corpId, password) => {
//     try {
//         const tokenData = await getToken();
//         const response = await axios.get(
//             `${PAYABLE_API_URL}/v1/ValidatePassword?CorpID=${corpId}&Password=${password}`,
//             authHeaders(tokenData?.token)
//         );
//         return response.data || null;
//     } catch (error) {
//         if (error.response?.status === 401) {
//             handleSessionTimeout();
//         }
//         console.error("Error checking lock status:", error);
//         throw error;
//     }
// };
